<template>
<ViskaseCard>
    <template v-slot:title>
        <span v-html="title"></span>
    </template>
    <template v-slot:default>
        <div class="row">
            <div class="col-12 col-sm-6">
                <div class="logo mx-5">
                    <img class="img-fluid" src="assets/img/reception-desk.png" alt="Image" />
                </div>
            </div>
            <div class="col-12 col-sm-6">
                <div class="m-1 p-1 fw-bold h3">
                    <span class="viskase-orange-text fw-bold">{{selectedCasing.title}}</span> - {{information_meeting}}
                </div>
                <div v-html="please_go_to_reception" class="m-1 p-1"> </div>
                <div v-html="keep_in_touch" class="m-1 p-1 fw-bold h3">
                </div>
                <div v-html="if_your_are_interested" class="m-1 p-1">
                </div>
                <div class="mt-3 m-1 p-1">
                    <input type="email" class="form-control" :placeholder="email_placeholder">
                </div>
                <div class="m-1 p-1 marketing pt-3"> 
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeAll">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_all"></label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeProcessing">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_12months"></label>
                    </div>
                    <div class="intro-contact pt-1" v-html="intro_contact"></div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreePhone">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_phone"></label>
                    </div>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" v-model="agreeEmail">
                        <label class="form-check-label" for="flexSwitchCheckDefault" v-html="accept_email"></label>
                    </div>
                    <div class="summary-contact pt-1" v-html="summary_contact"></div>
                    <div class="summary-policy" v-html="read_more_privacy_policy"></div>
                </div>
            </div>
        </div>
    </template>
</ViskaseCard>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ViskaseCard from "@/components/core/ViskaseCard.vue";
import ViskaseTile from "@/components/core/ViskaseTile.vue";
import { mapProperties } from "@/utilities/vuex";

export default {
  name: "Meeting",
  components: {
    ViskaseCard,
    ViskaseTile,
  },
  mounted() {
    this.offerName = "";
    this.offerCompany = "";
    this.offerPhone = "";
    this.offerEmail = "";
    this.agreeAll = false;
    this.agreeProcessing = false;
    this.agreePhone = false;
    this.agreeEmail = false;
    debugger;
    for (const element of this.offerCasings) {
      if (element.name === this.selectedCasing.name) {
        element.selected = true;
      }
    }
  },

  data() {
    return {};
  },
  watch: {
    agreeAll() {
      if (this.agreeAll === true) {
        this.agreeProcessing = true;
        this.agreePhone = true;
        this.agreeEmail = true;
      }
    },
  },

  methods: {
    ...mapActions([]),
    ...mapMutations([]),
  },
  computed: {
    ...mapState(["selectedCasing", "cards", "offerCasings"]),
    ...mapProperties([
      "offerName",
      "offerPhone",
      "offerCompany",
      "offerEmail",
      "agreeAll",
      "agreeProcessing",
      "agreePhone",
      "agreeEmail",
    ]),
    intro_contact() {
      return this.cards.meeting.intro_contact;
    },
    email_placeholder() {
      return this.cards.meeting.email_placeholder;
    },
    keep_in_touch() {
      return this.cards.meeting.keep_in_touch.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (this.selectedCasing || {}).title +
          "</span>"
      );
    },
    if_your_are_interested() {
      return this.cards.meeting.if_your_are_interested.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (this.selectedCasing || {}).title +
          "</span>"
      );
    },
    information_meeting() {
      return this.cards.meeting.information_meeting.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (this.selectedCasing || {}).title +
          "</span>"
      );
    },
    email() {
      return this.cards.meeting.email;
    },
    please_go_to_reception() {
      return this.cards.meeting.please_go_to_reception.replace(
        /{selectedCasing}/g,
        "<span class='viskase-orange-text fw-bold'>" +
          (this.selectedCasing || {}).title +
          "</span>"
      );
    },
    marketing_consents() {
      return this.cards.meeting.marketing_consents;
    },
    accept_all() {
      return this.cards.meeting.accept_all;
    },
    accept_12months() {
      return this.cards.meeting.accept_12months;
    },
    accept_phone() {
      return this.cards.meeting.accept_phone;
    },
    accept_email() {
      return this.cards.meeting.accept_email;
    },
    summary_contact() {
      return this.cards.meeting.summary_contact;
    },
    read_more_privacy_policy() {
      return this.cards.meeting.read_more_privacy_policy;
    },
  },
};
</script> 

<style scoped>
.marketing-consents,
.marketing label,
.intro-contact,
.summary-contact,
.summary-policy {
  font-size: 0.8rem;
}
</style>
